import { inject, provide, ref, type InjectionKey, type Ref } from 'vue'
import type { MarketPortalView } from '../mock/types'

export interface MarketPortalContext {
  view: Ref<MarketPortalView>
  categoryId: Ref<number>
  searchKeyword: Ref<string>
  editorTemplateId: Ref<number | undefined>
  goto: (view: MarketPortalView, categoryId?: number) => void
  openEditor: (templateId?: number) => void
  doSearch: (keyword: string) => void
  toast: (msg: string) => void
}

export const MARKET_PORTAL_KEY: InjectionKey<MarketPortalContext> = Symbol('MarketPortal')

export function provideMarketPortal() {
  const message = useMessage()
  const view = ref<MarketPortalView>('market')
  const categoryId = ref(0)
  const searchKeyword = ref('')
  const editorTemplateId = ref<number>()

  const toast = (msg: string) => {
    message.info(msg)
  }

  const goto = (next: MarketPortalView, cid?: number) => {
    view.value = next
    if (typeof cid === 'number') categoryId.value = cid
    if (next === 'market') window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const openEditor = (templateId?: number) => {
    editorTemplateId.value = templateId
    view.value = 'editor'
  }

  const doSearch = (keyword: string) => {
    const kw = keyword.trim()
    if (!kw) {
      toast('请输入关键词')
      return
    }
    searchKeyword.value = kw
    view.value = 'search'
  }

  const ctx: MarketPortalContext = {
    view,
    categoryId,
    searchKeyword,
    editorTemplateId,
    goto,
    openEditor,
    doSearch,
    toast
  }
  provide(MARKET_PORTAL_KEY, ctx)
  return ctx
}

export function useMarketPortal() {
  const ctx = inject(MARKET_PORTAL_KEY)
  if (!ctx) throw new Error('useMarketPortal must be used within MarketPortal')
  return ctx
}
